"use client";

import { useSiteUiCopy } from "./use-site-ui-copy";
import { getSiteUiCopy } from "@/lib/site-ui-copy";
import type { Lang } from "@/lib/types";
import type { CSSProperties } from "react";
import { STALE_TAB_OVERLAY_FADE_MS } from "@/lib/stale-tab-overlay";

type CcSiteChromeOverlayProps = {
  label?: string;
  lang?: Lang;
  visible: boolean;
  present: boolean;
};

export function CcSiteChromeOverlay({ label, lang, visible, present }: CcSiteChromeOverlayProps) {
  const contextCopy = useSiteUiCopy();
  const copy = lang ? getSiteUiCopy(lang) : contextCopy;
  return (
    <div
      className="cc-site-chrome-overlay"
      data-visible={visible}
      data-present={present}
      style={{ "--cc-reload-fade": `${STALE_TAB_OVERLAY_FADE_MS}ms` } as CSSProperties}
      role="status"
      aria-live={present ? "polite" : "off"}
      aria-hidden={!present}
    >
      <div className="cc-site-chrome-overlay__ring" aria-hidden="true" />
      <p className="cc-site-chrome-overlay__label">{label ?? copy.updating}</p>
    </div>
  );
}
